import { useEffect } from 'react';
import {
  hideBackButton,
  isBackButtonMounted,
  mountBackButton,
  onBackButtonClick,
  showBackButton,
} from '@telegram-apps/sdk-react';
import { insideTelegram, safe } from './env';

/** Системная «назад» вместо своей стрелки в шапке. */
export function useBackButton(onBack?: () => void): void {
  useEffect(() => {
    if (!insideTelegram() || !mountBackButton.isAvailable()) return;

    safe(() => {
      if (!isBackButtonMounted()) mountBackButton();
    });

    if (!onBack) {
      safe(() => hideBackButton());
      return;
    }

    safe(() => showBackButton());
    const off = safe(() => onBackButtonClick(onBack));

    return () => {
      off?.();
      safe(() => hideBackButton());
    };
  }, [onBack]);
}
